import type { WhatsAppTranslations } from '../interfaces/whatsapp';

export const whatsAppTranslations: WhatsAppTranslations = {
  chatTitle: 'Chat',

  integrationSectionTitle: 'WhatsApp Business',
  integrationSectionDescription:
    'Conecta tu cuenta de WhatsApp Business para que tu agente reciba y responda mensajes en tu nombre.',
  connectCardTitle: 'Conecta tu WhatsApp Business',
  connectCardDescription:
    'Te llevamos a Meta para autorizar la conexión, elegir tu número y conceder los permisos. Tú controlas qué se autoriza.',
  connectButton: 'Conectar mi WhatsApp Business',
  connectingLabel: 'Conectando…',
  connectedBadge: 'Conectado',
  connectedAtLabel: 'Conectado el',
  verifiedNameLabel: 'Nombre verificado',
  phoneNumberLabel: 'Número',
  businessIdLabel: 'ID del portafolio de negocio',
  businessIdMissing: 'No disponible — vuelve a conectar para gestionar plantillas',
  wabaIdLabel: 'WABA ID',
  phoneNumberIdLabel: 'Phone Number ID',
  technicalDetailsLabel: 'Detalles técnicos',
  reconnectButton: 'Reconectar con otra cuenta',
  syncPhonesButton: 'Sincronizar números',
  syncPhonesSuccess: 'Números sincronizados',
  syncPhonesError: 'No se pudieron sincronizar los números',
  reconnectDialogTitle: '¿Reconectar tu WhatsApp Business?',
  reconnectDialogDescription:
    'Esto reemplazará la conexión actual por la nueva cuenta que elijas en Meta.',
  reconnectDialogConfirm: 'Sí, reconectar',
  reconnectDialogCancel: 'Cancelar',
  switchToManualButton: 'Cambiar a token de acceso',
  disconnectButton: 'Desconectar',
  disconnectDialogTitle: '¿Desconectar WhatsApp Business?',
  disconnectDialogDescription:
    'Tu agente dejará de recibir y responder mensajes en este número. Podrás volver a conectarlo cuando quieras, con Facebook o con un token de acceso.',
  disconnectDialogConfirm: 'Sí, desconectar',
  disconnectDialogCancel: 'Cancelar',
  disconnectSuccess: 'WhatsApp desconectado.',
  disconnectError: 'No pudimos desconectar tu WhatsApp. Inténtalo de nuevo.',
  sdkLoadError:
    'No pudimos cargar el SDK de Facebook. Desactiva tu adblocker o revisa tu conexión.',
  cancelledMessage: 'Cerraste el diálogo de Meta antes de terminar.',
  successToast: '¡WhatsApp conectado correctamente!',
  errorStepExchangeCode:
    'El proceso expiró. Vuelve a iniciar la conexión desde cero.',
  errorStepDebugToken:
    'No pudimos validar tu cuenta de WhatsApp Business. Verifica que la diste de alta correctamente en Meta.',
  errorStepVerifyToken:
    'El token que pegaste no está autorizado para esa cuenta de WhatsApp Business. Revisa el WABA ID y los permisos del token.',
  errorStepPhoneNumbers:
    'Tu cuenta de WhatsApp Business no tiene un número de teléfono. Regístralo en Meta Business Suite y vuelve a intentar.',
  errorStepSubscribeApps:
    'No pudimos suscribirnos a tus mensajes de WhatsApp. Si tienes otra plataforma conectada, desconéctala primero.',
  errorStepPersist:
    'Error guardando tu conexión. Inténtalo de nuevo en un momento.',
  errorStatusLoad:
    'No pudimos cargar el estado de tu conexión. Intenta de nuevo.',
  errorUnknown: 'Ocurrió un error inesperado. Inténtalo de nuevo.',
  retryButton: 'Reintentar',
  redirectDisclaimer:
    'Te redirigimos a Meta para autorizar la conexión. Tú controlas los permisos.',

  configureButton: 'Configurar canal',
  tilePhonesCount: '{{count}} número',
  drawerTitle: 'WhatsApp Business · canal',
  drawerDescription:
    'Detalles de conexión, agente por defecto y vínculos por número.',

  manualConnectLink: 'Conectar con credenciales',
  manualDrawerTitle: 'Conectar con credenciales',
  manualDrawerDescription:
    '¿Ya tienes un token de System User en Meta Business Manager? Pégalo aquí junto con tu WABA ID y validaremos y registraremos tu cuenta.',
  manualAccessTokenLabel: 'Token de acceso',
  manualAccessTokenPlaceholder: 'EAAGm0PX...',
  manualAccessTokenHelp:
    'Token largo de System User con los permisos whatsapp_business_management y whatsapp_business_messaging.',
  manualWabaIdLabel: 'ID de la cuenta de WhatsApp Business',
  manualWabaIdPlaceholder: '102290129340398',
  manualWabaIdHelp:
    'ID numérico del WABA al que el token está autorizado. Lo encuentras en Meta Business Manager.',
  manualBusinessIdLabel: 'ID del portafolio de negocio (opcional)',
  manualBusinessIdPlaceholder: '1174430681268289',
  manualBusinessIdHelp: 'Lo ves en Configuración del negocio → Información del negocio. Sin este dato no podrás crear ni sincronizar plantillas.',
  manualBusinessIdInvalid: 'El ID solo puede tener números',
  manualSubmit: 'Conectar',
  manualReplaceSubmit: 'Reemplazar conexión',
  manualReplaceWarningTitle: 'Ya tienes una cuenta conectada',
  manualReplaceWarningDescription:
    'Al continuar reemplazarás la conexión actual (WABA {{wabaId}}) por la que autoricen estas credenciales.',
  manualSuccess: '¡WhatsApp conectado correctamente!',
  manualAccessTokenRequired: 'Pega tu token de acceso para continuar.',
  manualWabaIdRequired: 'Ingresa tu WABA ID para continuar.',
  manualWabaIdInvalid: 'El WABA ID debe ser numérico.',

  manualGuideTitle: 'Cómo obtener estas credenciales',
  manualGuideStep1:
    'Abre Meta Business Manager y elige el negocio dueño de tu cuenta de WhatsApp.',
  manualGuideStep1Link: 'Abrir Business Manager',
  manualGuideStep2:
    'En Configuración del negocio → Cuentas → Cuentas de WhatsApp, selecciona tu WABA y copia su ID (visible en la URL y en el panel lateral).',
  manualGuideStep2Link: 'Abrir Cuentas de WhatsApp',
  manualGuideStep3:
    'En Configuración del negocio → Usuarios → Usuarios del sistema, crea o elige un System User, haz clic en "Generar nuevo token", selecciona tu app de Meta y los permisos de abajo, y copia el token.',
  manualGuideStep3Link: 'Abrir Usuarios del sistema',
  manualGuideScopes:
    'Permisos requeridos del token: whatsapp_business_management y whatsapp_business_messaging.',
  manualGuideDocsLink: 'Leer la guía oficial de Meta',
};
